import { useState, useEffect } from 'react';

function readIsHorizontal(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth > 1100;
}

/**
 * Hook para detectar si debe aplicarse el layout horizontal
 * SOLO activa el layout horizontal cuando el ancho de pantalla es > 1100px
 * Independiente de la orientación física del dispositivo o tipo de dispositivo
 * (móvil, tablet, desktop, etc.)
 */
export const useOrientation = () => {
  // Valor inicial síncrono: evita un frame en vertical antes del layout real (titileos).
  const [isHorizontal, setIsHorizontal] = useState(readIsHorizontal);

  useEffect(() => {
    const checkOrientation = () => {
      setIsHorizontal(readIsHorizontal());
    };

    checkOrientation();

    let resizeTimeout: ReturnType<typeof setTimeout>;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(checkOrientation, 50);
    };

    const handleOrientationChange = () => {
      setTimeout(checkOrientation, 100);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return isHorizontal;
};
